import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ChampSourceGarantie } from "src/app/parametrage/core/model/garanties/ChampSourceGarantie";
import { TypeDocumentChampGarantieService } from "src/app/parametrage/core/service/type-document-champ-garantie.service";

@Component({
  selector: "app-add-champ-source-garantie",
  templateUrl: "./add-champ-source-garantie.component.html",
  styleUrls: ["./add-champ-source-garantie.component.scss"],
})
export class AddChampSourceGarantieComponent implements OnInit {
  champSourceGarantie: ChampSourceGarantie;
  form: FormGroup;
  pressButton: Boolean = false;
  title: string;
  loading = false;
  submitted = false;
  errorMessage: string;

  constructor(
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private _champSourceGarantieService: TypeDocumentChampGarantieService
  ) {}

  ngOnInit() {
    this.form = this.createForm(this.champSourceGarantie);
  }

  createForm(data: ChampSourceGarantie) {
    if (data) {
      return this.fb.group({
        id: [data ? data.id : ""],
        codeChamp: [
          data ? data.codeChamp : "",
          Validators.compose([Validators.required]),
        ],
        libelleChamp: [data ? data.libelleChamp : ""],
        typeChamp: [data ? data.typeChamp : null],
      });
    } else {
      return this.fb.group({
        id: [data ? data.id : ""],
        codeChamp: ["", Validators.compose([Validators.required])],
        libelleChamp: ["", Validators.compose([Validators.required])],
        typeChamp: ["", Validators.compose([Validators.required])],
      });
    }
  }

  onSubmit() {
    this.submitted = true;
    this.findInvalidControls();
    if (this.form.invalid) {
      return;
    }
    this.loading = true;
    if (!this.champSourceGarantie) {
      this.createData();
    } else {
      this.updateData();
    }
  }

  createData() {
    this._champSourceGarantieService
      .addChampSourceGarantie(this.form.value)
      .subscribe(
        (data) => {
          this.activeModal.close();
        },
        (error) => {
          if (error && error.error && error.status == 409) {
            this.errorMessage = error.error.message;
          }
        }
      );
  }

  updateData() {
    this._champSourceGarantieService
      .updateChampSourceGarantie(this.champSourceGarantie.id, this.form.value)
      .subscribe(
        (data) => {
          this.activeModal.close();
        },
        (error) => {
          if (error && error.error && error.status == 409) {
            this.errorMessage = error.error.message;
          }
        }
      );
  }

  public findInvalidControls() {
    const invalid = [];
    const controls = this.form.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }
    console.log(invalid);
  }
}
